<div class="operatingMain">
  <div class="tableMenu">
    <p class="title">Please select your operating mode</p>
    <div class="icon">
      <img class="deviceIcon" [src]="iconePath" />
    </div>
    <div class="choice-holder">
      @for (nav of navigators; track nav) {
        <div
          class="choiceLine"
          (click)="choiceUpdated(nav)"
          >
          <div class="checkBoxChoice">
            <input
              class="checkBox"
              type="image"
              [src]="nav.isSelected ? nav.checked : pathcheckUndefined"
              />
          </div>
          <div class="textChoice">
            <p>{{ nav.name }}</p>
          </div>
        </div>
      }
    </div>
  </div>
  <div class="modeFooter">
    <button
      class="goNext"
      mat-button
      [disabled]="!selection"
      (click)="choiceMade()"
      >
      NEXT <mat-icon class="nextIcon">navigate_next</mat-icon>
    </button>
  </div>
</div>
